import { render, staticRenderFns } from "./project-custon.vue?vue&type=template&id=6cbea794&scoped=true&"
import script from "./project-custon.vue?vue&type=script&lang=js&"
export * from "./project-custon.vue?vue&type=script&lang=js&"
import style0 from "./project-custon.vue?vue&type=style&index=0&id=6cbea794&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbea794",
  null
  
)

export default component.exports